<template>
  <span>
    <button ref="dropdownTrigger" data-toggle="dropdown" :class="['btn', displayDownArrow ? 'dropdown-toggle' : '', buttonClass]" type="button">
      <i v-if="icon" v-bind:class="['fa', icon]"></i> {{title}}
    </button>
    <ul ref="dropdownMenu" class="dropdown-menu">
      <slot />
    </ul>
  </span>
</template>

<script>
export default {
  props: {
    title: String,
    icon: {
      type: String,
      default: ''
    },
    buttonClass: {
      type: String,
      default: "btn-sm btn-default"
    },
    displayDownArrow: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    hideDropdown() {
      if($(this.$refs.dropdownMenu).hasClass('show')) {
        $(this.$refs.dropdownTrigger).dropdown('toggle')
        $(this.$refs.dropdownTrigger).dropdown('update')
      }
    }
  }
}
</script>